import { Box, Flex, Text } from "@mantine/core"
import { useContext, useEffect } from "react"
import SingleCustomerContext from "../../Customer-Context/SingleCustomerContext"
import { MAIN_DARK_PRIMARY } from "../../../../constants/colors"
import CustomerAttributes from "./CustomerAttributes"
import CustomersBars from "./CustomersBars"

const CustomerHeader = () => {

  const { customer, viewType} = useContext(SingleCustomerContext)

  return (
    <Box>
      <Flex gap={8}>
        
        {viewType === 'single' ?

          <Box>
            <Text fz={18} fw={600} color={MAIN_DARK_PRIMARY} align="start">
              {customer?.name}
            </Text>
            <CustomerAttributes/>
          </Box>
          : 
          <CustomersBars/>  
        }
      </Flex>
    </Box>
  )
}

export default CustomerHeader